var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"title":_vm.title,"show":_vm.show,"close-show":true,"footerBtnShow":false},on:{"update:show":function($event){_vm.show=$event}}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"info",domProps:{"innerHTML":_vm._s(_vm.message)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc709b0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/message.vue
// module id = null
// module chunks = 